import React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import {ErrorBounds} from './components/error';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from "react-redux";
import { createBrowserHistory } from 'history';
import configureStore from './configureStore';
import { addLocaleData } from 'react-intl';

//Languages Supported So Far..
import en from 'react-intl/locale-data/en';
import nl from 'react-intl/locale-data/nl';
import ru from 'react-intl/locale-data/ru';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';
import gr from 'react-intl/locale-data/el';
import rs from 'react-intl/locale-data/sr';
import ro from 'react-intl/locale-data/ro';
import tr from 'react-intl/locale-data/tr';
import cs from 'react-intl/locale-data/cs';
import it from 'react-intl/locale-data/it';
import es from 'react-intl/locale-data/es';


import {StaticRouter} from "react-router";
// eslint-disable-next-line import/default

import Home from "./pages/home";
import About from "./pages/about";
import Page404 from "./pages/page404";
import Login from "./pages/login";
import Advertise from "./pages/advertise";
import Support from "./pages/support";
import Confirm from "./pages/confirm";
import SignUp from "./pages/signup";
import ResetPassword from "./pages/resetpassword";
import Links from "./pages/links";
import Terms from "./pages/terms";
import Privacy from "./pages/privacy";
import SiteMap from "./pages/sitemap";
import Blog from "./pages/blog";
import Pay from "./pages/pay";


import {Route, BrowserRouter, Switch, withRouter} from "react-router-dom";
import * as wActs from "./actions/website-actions";

addLocaleData([...en, ...nl, ...ru, ...fr, ...de, ...gr, ...rs, ...ro, ...tr, ...cs, ...it, ...es]);

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

const initialState = (window).initialReduxState;


const htmlSections = JSON.parse(atob(window.htmlSectionsEncoded));
initialState.Website.Settings.HtmlSections = htmlSections;

function genRoutes(routes,store) {

  let rtes = routes;

  const state = store.getState();
  const locPth = state.Website.Settings.LocationPath;
  const doDyn = wActs.isNullOrUndefined(state.Website.Settings.TagsInLinksEnabled) ? false : state.Website.Settings.TagsInLinksEnabled;

  let tags = rtes.map((v,i) => {

    let ren = (props)=><Home pageType={"home"} dynamiclink={false} {...props} />;
    switch(v.template.toLowerCase()) {
      case "home", "custom": {
        break;
      }
      case "pay": {
        ren = (props) => <Pay pageType={"pay"} {...props} />;
        break;
      }
      case "advertise": {
        ren = (props) => <Advertise pageType={"advertise"} {...props} />;
        break;
      }
      case "sitemap": {
        ren = (props) => <SiteMap pageType={"sitemap"} {...props} />;
        break;
      }
      case "support": {
        ren = (props)=><Support pageType={"links"} {...props} />;
        break;
      }
      case "links": {
        ren = (props)=><Links pageType={"home"} {...props} />;
        break;
      }
      case "confirm": {
        ren = (props) => <Confirm pageType={"confirm"} {...props} />;
        break;
      }
      case "about": {
        ren = (props)=><About pageType={"home"} {...props} />;
        break;
      }
      case "terms": {
        ren = (props)=><Terms pageType={"home"} {...props} />;
        break;
      }
      case "privacy": {
        ren = (props)=><Privacy pageType={"home"} {...props} />;
        break;
      }
      case "login": {
        ren = (props) => <Login pageType={"login"} {...props} />;
        break;
      }
      case "signup": {
        ren = (props) => <SignUp pageType={"signup"} {...props} />;
        break;
      }
      case "resetpassword": {
        ren = (props) => <ResetPassword pageType={"resetpassword"} {...props} />;
        break;
      }
      case "404": {
        ren = (props) => <Page404 pageType={"404"} {...props} />;
        break;
      }
      case "blog": {
        ren = (props) => <Blog pageType={"blog"} {...props} />;
        break;
      }

      default: {
        break;
      }
    }
    if(v.path === "") {
      v.path = "/";
    }
    return (
      <Route
        key={"rtr-main-" + i}
        path={v.path}
        exact
        render={ren} />
    );
  });

  return tags;
}


function renderApp() {
  let his = null;
  const renderMethod = !module.hot ? ReactDOM.render : ReactDOM.hydrate;

  //console.log(initialState.Website.Page.Name)

  //if(initialState.Website.Page.Name === "404") {
  //  withRouter(({history}) => {
  //    history.push('en/4042234234');
  //    his = history;
  //  });
  //}
  let store = configureStore(his,initialState);

  ReactDOM.hydrate((
    <ErrorBounds>
    <Provider store={store}>
      <BrowserRouter >
        <App>
          <Switch>
            {genRoutes(initialState.Website.Routes, store)}
            <Route
              key={"rtr-404"}
              render={(props) => <Page404 pageType={"404"} {...props} />} />
          </Switch>
        </App>
      </BrowserRouter>
    </Provider>
    </ErrorBounds>
  ), document.getElementById('main-scrollbar'));
}



renderApp();

if(module.hot) {
  module.hot.accept('./App.js', () => {
    //routes = require('./routes').routes;
    renderApp();
  });
}
registerServiceWorker();
